import { c as _c } from "react/compiler-runtime";
import type { RefObject } from "react";
interface NftSuggestSentinelProps {
  readonly top: number;
  readonly height: number;
  readonly sentinelRef: RefObject<HTMLDivElement | null>;
  readonly hasSuggestions: boolean;
}
export function NftSuggestSentinel(t0) {
  const $ = _c(12);
  const {
    top,
    height,
    sentinelRef,
    hasSuggestions
  } = t0;
  let t1;
  if ($[0] !== height || $[1] !== top) {
    t1 = {
      top,
      height
    };
    $[0] = height;
    $[1] = top;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      height: "100%",
      width: "100%"
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== sentinelRef) {
    t3 = <div ref={sentinelRef} style={t2} />;
    $[4] = sentinelRef;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== hasSuggestions) {
    t4 = !hasSuggestions && <div className="tw-flex tw-h-full tw-items-center tw-justify-center tw-px-3 tw-text-sm tw-text-iron-400">No suggestions available</div>;
    $[6] = hasSuggestions;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
    t5 = <li key="suggestions-sentinel" className="tw-absolute tw-w-full" style={t1} aria-hidden="true">{t3}{t4}</li>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}